import React from 'react';
import classes from './style.module.css'
import { GREYHOUND_TABLE_ALL_STATIC, GREYHOUND_TABLE_COLUMNS_STATIC, AVEGAGE_SWITCH } from '../../../constants/Constants'
import OddResultCell from './OddResultCell'
import WinDetailCell from './WinDetailCell'
import StarRatings from 'react-star-ratings';
import { useSelector } from 'react-redux';

const getRating = (lastRunStatusList, index) => {
    if (lastRunStatusList && lastRunStatusList.length > index) {
        const rating = lastRunStatusList[index].rating
        return Math.floor(rating * 100) / 100;
    }
    return "-";

}

const roundOff = (reating) => {
    return Math.floor(reating * 100) / 100;
}
const League = (props) => {
    const rowIndex = props.index + 1;
    const id = props.item.time;
    const type = props.type;
    const columnList = props.finalColumns;
    const averageSwitch = useSelector(state => state.averageSwitch);
    const cells = columnList.map(column => {
        let cell = null;
        const cellKey = id + "_" + column.id
        //console.log(props.item.raceId)
        switch (column.id) {
            case GREYHOUND_TABLE_COLUMNS_STATIC.ROW_NUM.id:
                cell = <th key={cellKey} className={classes.LeagueTdTh} scope="row">{rowIndex}</th>
                break;
            case GREYHOUND_TABLE_ALL_STATIC.TRACK.id:
                cell = <th key={cellKey} className={classes.LeagueTdTh} scope="row">{props.item.trackName}
                    {type === 'ALL' ? ' R' + props.item.raceId : ''}
                </th>
                break;
            case GREYHOUND_TABLE_ALL_STATIC.TIME.id:
                cell = <th key={cellKey} className={classes.LeagueTdTh} scope="row">{props.item.raceTime}</th>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.BOX.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.box}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.DOG_NAME.id:
                cell = (<td style={{ width: "300px" }} key={cellKey} className={classes.LeagueTdTh}>{props.item.runner}
                    &nbsp; &nbsp; &nbsp;
                    <div style={{ float: "right" }}>
                        <StarRatings
                            starDimension="20px"
                            starSpacing="0"
                            rating={props.item.overallRating}
                            starRatedColor="blue"
                            numberOfStars={4}
                            name='rating'
                        />
                    </div>
                </td>)
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.FORM.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.last5Run}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.WIN_PERCENT.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.winPercent}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.PLACE_PERCENT.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.placePercent}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.DAYS_SINCE_LAST_RUN.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.daysSinceLastRun}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.FIFTH_RATING.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{getRating(props.item.lastRunStatusList, 4)}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.FOURTH_RATING.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{getRating(props.item.lastRunStatusList, 3)}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.THIRD_RATING.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{getRating(props.item.lastRunStatusList, 2)}</td>
                break;

            case GREYHOUND_TABLE_COLUMNS_STATIC.SECOND_RATING.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{getRating(props.item.lastRunStatusList, 1)}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.LAST_RATING.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{getRating(props.item.lastRunStatusList, 0)}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.AVERAGE_RATING.id:
                var average = props.item.averageRating;
                if(averageSwitch == AVEGAGE_SWITCH.LAST_3.id){
                    average = props.item.lsst3AverageRating;
                }else if(averageSwitch == AVEGAGE_SWITCH.LAST_4.id){
                    average = props.item.lsst4AverageRating;
                } 
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{roundOff(average)}</td>
                break;

            case GREYHOUND_TABLE_COLUMNS_STATIC.LENGTH_ADVANTAGE.id:
                var lengthAdvantage = props.item.lengthAdvantage;
                if(averageSwitch == AVEGAGE_SWITCH.LAST_3.id){
                    lengthAdvantage = props.item.lengthLast3Advantage;
                }else if(averageSwitch == AVEGAGE_SWITCH.LAST_4.id){
                    lengthAdvantage = props.item.lengthLast4Advantage;
                } 
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{roundOff(lengthAdvantage)}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.PRIZE_MONEY_IND.id:
                cell = <td key={cellKey} className={classes.prizedMoneyInd}>{roundOff(props.item.prizedMoneyInd)}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.ODD_DETAILS.id:

                let part = props.item;
                console.log(JSON.stringify(part))
                let details = "-,-"
                if (part.bfSelectionId && part.bfMarketId) {
                    details = <OddResultCell date={props.date} oddChangeCallback={props.oddChangeCallback} marketId={part.bfMarketId} selectionId={part.bfSelectionId} />
                }
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{details}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.WIN_DETAILS.id:
                let currentItem = props.item;
                let winnerDetails = "-"
                if (currentItem.bfSelectionId && currentItem.bfMarketId) {
                    winnerDetails = <WinDetailCell marketId={currentItem.bfMarketId}
                        date={props.date} time={props.item.raceTime}
                        selectionId={currentItem.bfSelectionId} />
                }
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{winnerDetails}</td>
                break;
            default:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>-</td>
        }
        return cell;
    })

    return (
        <tr className={classes.League}>
            {cells}
        </tr>
    )
}

export default League;